import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useFetchStore } from '@/stores/fetch'
import type { IConfig } from '@/types/User'

/*
 * THE API'S VERSION as GET /config reports it (CLAUDE.md → Versions) — for the sidebar's footer.
 * Asked once per page load: on a phone the drawer mounts the sidebar anew every time it opens. An
 * API that does not answer is asked again the next time.
 */
export const useApiVersionStore = defineStore('apiVersion', () => {
    const fetchStore = useFetchStore()

    const version = ref('')

    let pending: Promise<void> | null = null

    const ask = async (): Promise<void> => {
        const { statusCode, data } = await fetchStore.fetch('/config').get().json<IConfig>()

        if (statusCode.value === 200 && data.value?.version) version.value = data.value.version
    }

    /** The version, asked for at most once at a time, and no more once it is known. */
    const load = (): Promise<void> => {
        if (version.value) return Promise.resolve()

        pending ??= ask().finally(() => { pending = null })

        return pending
    }

    return { version, load }
})
